"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = exports.ChildrenWrapper = exports.TitleText = exports.TitleWrapper = exports.Content = exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Wrapper = styled_components_1.default.div `
  position: absolute;
  display: block;
  margin: auto;
  z-index: 99;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: white;

  box-sizing: border-box;
  height: 100%;
  width: 100%;
  max-width: 1024px;
  /* transform: translate(-50%); */

  @keyframes slidein {
    from {
      left: 100%;
    }
    to {
      left: 0;
    }
  }

  @keyframes slideout {
    from {
      left: 0;
    }
    to {
      left: 100%;
    }
  }

  ${({ state, duration }) => (0, styled_components_1.css) `
    animation-duration: ${duration}ms;

    animation-name: ${state === "entered" || state === "entering"
    ? "slidein"
    : "slideout"};

    left: ${state === "entered" || state === "entering" ? 0 : "100%"};
  `}
`;
exports.Content = styled_components_1.default.div `
  width: 100%;
  max-width: 835px;
  margin: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
`;
exports.TitleWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  position: relative;
  padding: 24px;
`;
exports.TitleText = styled_components_1.default.div `
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  text-align: center;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
exports.ChildrenWrapper = styled_components_1.default.div `
  height: 100%;
  overflow: auto;
`;
exports.CloseButton = styled_components_1.default.div `
  background: none;
  border: none;
  position: absolute;
  cursor: pointer;
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=styled.js.map